import { apiToken, chatApiUrl, chatSessionURl } from "../config";

// chat api start
export const chatApi = async (payload) =>  {
    try{
        const response = await fetch(chatApiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                 Authorization: `Bearer ${apiToken}`

            },
            body: JSON.stringify(payload),
        });
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || 'Failed to fetch');
        }
        return res;
    } catch(e) {
        throw new Error(e.message || "Something went wrong");
    }
}

// chat api end 


// get chat session detail start
export const getChatSessionDetails = async (sessionId) => {
    try {
        const response = await fetch(`${chatSessionURl}${sessionId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            }
        })
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Failed to fetch the data")
        }
        return res;
    } catch(e) {
        throw new Error(e.message || "Something went wrong");
    }
}
// get chat session end